import { cloneElement, createContext, useContext, useState } from "react";

export const GlobalContext = createContext<any>({});

export const useGlobalContext = (): any => useContext(GlobalContext);

let updateGlobalContext: any;

export const GlobalProvider = ({ children }: { children: any }) => {
  const [data, setData] = useState<any>({});
  const renderBody = (ele: any) => cloneElement(ele);

  updateGlobalContext = (newData: any) => {
    setData((prev: any) => ({ ...prev, ...newData }));
  };

  const contextValue = { ...data };

  return (
    <GlobalContext.Provider value={contextValue}>
      {renderBody(children)}
    </GlobalContext.Provider>
  );
};

export { updateGlobalContext };
